import React, { useState } from 'react';
type BrandLogoProps = {
  src: string;
  label: string;
  className?: string;
};

/** Official brand mark on a white chip; falls back to the brand name if the asset fails to load. */
export function BrandLogo({
  src,
  label,
  className = 'h-6 w-[38px]'
}: BrandLogoProps) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <span className={`inline-flex items-center justify-center rounded-[3px] bg-white px-1 text-[8px] font-bold leading-none text-[#0B2037] ${className}`} title={label} data-id="element-757" data-mp="2931l776cc6nz">
        {label}
      </span>;
  }
  return <img src={src} alt={label} title={label} loading="lazy" decoding="async" onError={() => setFailed(true)} className={`rounded-[3px] object-contain ${className}`} data-id="element-758" data-mp="2nu25c9gg9ozy" />;
}